// flatpickr-init.js — v3.3 (calendar + intervale orare ca pastile; FĂRĂ selecție implicită, FĂRĂ restaurare)
// Inițializează flatpickr pe inputul #pickup_datetime.
// FOLOSEȘTE EXCLUSIV helpers din window.TRAVA_DELIVERY (vezi delivery-config.js).
// Lucrează pe desktop ȘI mobil (iOS Safari + Android Chrome).
//
// Ce s-a schimbat față de v2:
//  - Flatpickr afișează DOAR calendarul (enableTime: false). Ora nu se mai alege din
//    selectorul "HH : MM", ci din pastile cu intervalele zilei, generate din config
//    (getMinStartHour / lastStartHour → aceleași reguli de lead-time și program).
//  - Valoarea scrisă în câmp are EXACT același format: "YYYY-MM-DD HH:00 - HH+1:00".
//    Atributele delivery_date / delivery_time se salvează identic.
//    checkout-validation.js nu necesită nicio modificare.
//  - Calendarul rămâne deschis după alegerea zilei (closeOnSelect: false), ca să se
//    poată alege intervalul; "Confirmă" (sau click în afara lui) îl închide.
//  - Pe mobil, CSS-ul din main-cart-footer.liquid îl transformă în panou de jos
//    (clasa body.trava-fp-open pune fundalul întunecat).
//  - v3.2: NU se mai pre-alege niciun slot. Clientul alege explicit ziua ȘI intervalul;
//    câmpul rămâne gol (și atributele coșului goale) până atunci. Schimbarea zilei
//    anulează intervalul ales. Un interval expirat se anulează, nu se înlocuiește.
//  - v3.3: nicio restaurare. La fiecare încărcare a coșului câmpul e gol; selecția veche din
//    localStorage și atributele delivery_date / delivery_time rămase în coș se șterg la pornire.

(function () {
  'use strict';

  if (!window.TRAVA_DELIVERY) {
    console.error('[flatpickr-init] window.TRAVA_DELIVERY nu există. Asigură-te că delivery-config.js este încărcat ÎNAINTE de acest script.');
    return;
  }

  var TD = window.TRAVA_DELIVERY;
  var CONFIG = TD.CONFIG;

  // ═══════════════════════════════════════════════════════════════════════════
  // LOCALSTORAGE
  // ═══════════════════════════════════════════════════════════════════════════
  function saveLocal(selection) {
    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(selection));
    } catch (e) { /* quota / private mode */ }
  }

  function loadLocal() {
    try {
      return JSON.parse(localStorage.getItem(CONFIG.storageKey) || 'null');
    } catch (e) {
      return null;
    }
  }

  function clearLocal() {
    try { localStorage.removeItem(CONFIG.storageKey); } catch (e) {}
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // CURĂȚARE ATRIBUTE VECHI DIN CART-ul SHOPIFY (neschimbat)
  // ═══════════════════════════════════════════════════════════════════════════
  function cleanLegacyCartAttributes() {
    // + atributele de livrare: coșul pornește curat, clientul alege explicit în această vizită
    var legacyAttrs = ['Data ridicare', 'delivery_type', 'delivery_summary', CONFIG.attrKeys.date, CONFIG.attrKeys.time];
    var payload = { attributes: {} };
    legacyAttrs.forEach(function (k) { payload.attributes[k] = ''; });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function (err) {
      if (window.Shopify && window.Shopify.designMode) {
        console.warn('[TRAVA] cleanLegacyCartAttributes failed:', err);
      }
    });
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // INPUTURI HIDDEN PENTRU SHOPIFY CART ATTRIBUTES (neschimbat)
  // ═══════════════════════════════════════════════════════════════════════════
  function ensureHiddenInputsExist(retries) {
    retries = retries || 0;
    var form = document.getElementById('cart');
    if (!form) {
      if (retries < 20) setTimeout(function () { ensureHiddenInputsExist(retries + 1); }, 100);
      return;
    }

    var ensure = function (attrName, id) {
      var el = document.getElementById(id);
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = 'attributes[' + attrName + ']';
        el.id = id;
        el.setAttribute('form', 'cart');
        form.appendChild(el);
      }
      if (!el.hasAttribute('form')) el.setAttribute('form', 'cart');
    };

    ensure(CONFIG.attrKeys.date, 'attr_delivery_date');
    ensure(CONFIG.attrKeys.time, 'attr_delivery_time');
  }

  function setHiddenInputs(sel) {
    var d = document.getElementById('attr_delivery_date');
    var h = document.getElementById('attr_delivery_time');
    if (d) d.value = sel.date || '';
    if (h) h.value = sel.time || '';
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // SHOPIFY CART API (neschimbat)
  // ═══════════════════════════════════════════════════════════════════════════
  function updateCartAttributes(sel) {
    var attrs = {};
    attrs[CONFIG.attrKeys.date] = sel.date || '';
    attrs[CONFIG.attrKeys.time] = sel.time || '';
    attrs['delivery_type'] = '';
    attrs['delivery_summary'] = '';
    attrs['Data ridicare'] = '';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (window.Shopify && window.Shopify.designMode) {
          console.log('[TRAVA] cart attributes saved:', j.attributes);
        }
      })
      .catch(function (err) {
        console.error('[TRAVA] cart/update.js error:', err);
      });
  }

  function saveSelection(sel) {
    var full = { type: sel.type || '', date: sel.date, time: sel.time };
    setHiddenInputs(full);
    updateCartAttributes(full);
    saveLocal(full);
    if (window.Shopify && window.Shopify.designMode) {
      console.log('[TRAVA] selection saved:', full);
    }
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // LOCALIZARE RO + ETICHETE
  // ═══════════════════════════════════════════════════════════════════════════
  var RO_LOCALE = {
    firstDayOfWeek: 1,
    weekdays: {
      shorthand: ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S'],
      longhand: ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă']
    },
    months: {
      shorthand: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      longhand: ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie']
    },
    rangeSeparator: ' – ',
    weekAbbreviation: 'Săpt',
    scrollTitle: 'Derulează pentru a schimba',
    toggleTitle: 'Click pentru a comuta',
    time_24hr: true
  };

  function formatDayLabel(dateStr) {
    var p = dateStr.split('-');
    var d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10), 12, 0, 0);
    try {
      return d.toLocaleDateString('ro-RO', { weekday: 'long', day: 'numeric', month: 'long' });
    } catch (e) {
      return dateStr;
    }
  }

  function slotLabel(hour) {
    return TD.pad2(hour) + ':00 – ' + TD.pad2(hour + 1) + ':00';
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // INIȚIALIZARE FLATPICKR
  // ═══════════════════════════════════════════════════════════════════════════
  function initFlatpickr(retries) {
    retries = retries || 0;

    if (typeof flatpickr === 'undefined') {
      if (retries < 25) return void setTimeout(function () { initFlatpickr(retries + 1); }, 200);
      console.error('[flatpickr-init] flatpickr nu s-a încărcat după 5s.');
      return;
    }

    var input = document.querySelector(CONFIG.selectors.input);
    if (!input) {
      if (retries < 25) return void setTimeout(function () { initFlatpickr(retries + 1); }, 200);
      console.error('[flatpickr-init] ' + CONFIG.selectors.input + ' nu există.');
      return;
    }

    input.setAttribute('readonly', 'readonly');
    input.setAttribute('inputmode', 'none');
    input.setAttribute('autocomplete', 'off');

    ensureHiddenInputsExist();
    cleanLegacyCartAttributes();

    // ─── Tip livrare (UI intern only; neschimbat) ───
    var deliveryType = '';
    var toggleButtons = document.querySelectorAll(CONFIG.selectors.toggle);
    if (toggleButtons.length) {
      Array.prototype.forEach.call(toggleButtons, function (btn) {
        if (btn.classList.contains('active')) {
          deliveryType = btn.dataset.type || btn.textContent.trim() || '';
        }
      });
      Array.prototype.forEach.call(toggleButtons, function (btn) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(toggleButtons, function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          deliveryType = btn.dataset.type || btn.textContent.trim() || '';
          var parts = TD.parseInputValue(input.value);
          if (parts) saveSelection({ type: deliveryType, date: parts.dateStr, time: parts.timeStr });
        });
      });
    }

    var now = TD.nowInBucharest();
    var enableDates = TD.buildAllowedDates(now);

    if (!enableDates.length) {
      console.error('[flatpickr-init] Nicio dată disponibilă în următoarele ' + CONFIG.maxAdvanceDays + ' zile!');
      return;
    }

    // ─── Starea selecției: zi + ora de început. Ambele null până alege clientul. ───
    var state = { date: null, hour: null };
    var hasCommitted = false; // dacă există o valoare completă scrisă în câmp / coș

    // Nicio restaurare: orice selecție veche din browser se șterge; clientul alege acum
    clearLocal();

    // Lista intervalelor posibile pentru o zi (sau null dacă ziua nu mai are intervale)
    function slotRange(dateStr) {
      var hoursObj = TD.dayHours(dateStr);
      var minH = TD.getMinStartHour(dateStr, now);
      if (!hoursObj || minH === null) return null;
      var maxH = TD.lastStartHour(hoursObj);
      if (minH > maxH) return null;
      return { min: minH, max: maxH };
    }

    // Ora aleasă rămâne doar dacă e încă validă pentru ziua aleasă; altfel se anulează (NU se înlocuiește)
    function dropHourIfInvalid() {
      if (!state.date || state.hour === null) return;
      var r = slotRange(state.date);
      if (!r || state.hour < r.min || state.hour > r.max) state.hour = null;
    }

    // Scrie valoarea completă în câmp (ACELAȘI format ca înainte) și salvează în coș + localStorage
    function commit(instance) {
      if (!state.date || state.hour === null) return;
      instance.input.value = TD.formatDisplayValue(state.date, state.hour);
      instance.input.classList.remove('pickup-datetime-required');
      saveSelection({ type: deliveryType, date: state.date, time: TD.pad2(state.hour) + ':00' });
      hasCommitted = true;
      try {
        instance.input.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) { /* browsere foarte vechi */ }
    }

    // Golește câmpul; dacă exista o valoare salvată, o șterge și din coș + localStorage
    function clearValue(instance) {
      instance.input.value = '';
      if (hasCommitted) {
        setHiddenInputs({ date: '', time: '' });
        updateCartAttributes({ date: '', time: '' });
        clearLocal();
        hasCommitted = false;
      }
    }

    // ─── Panoul cu intervale orare (adăugat în calendarul flatpickr) ───
    var slotsEl = null, slotsTitle = null, slotsList = null, confirmBtn = null;

    function buildSlotsPanel(instance) {
      var grab = document.createElement('div');
      grab.className = 'trava-fp__grab';
      grab.setAttribute('aria-hidden', 'true');
      instance.calendarContainer.insertBefore(grab, instance.calendarContainer.firstChild);

      slotsEl = document.createElement('div');
      slotsEl.className = 'trava-slots';

      slotsTitle = document.createElement('div');
      slotsTitle.className = 'trava-slots__title';

      slotsList = document.createElement('div');
      slotsList.className = 'trava-slots__list';
      slotsList.setAttribute('role', 'group');
      slotsList.setAttribute('aria-label', 'Interval orar');

      confirmBtn = document.createElement('button');
      confirmBtn.type = 'button';
      confirmBtn.className = 'trava-slots__confirm';
      confirmBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (confirmBtn.disabled) return;
        instance.close();
      });

      slotsEl.appendChild(slotsTitle);
      slotsEl.appendChild(slotsList);
      slotsEl.appendChild(confirmBtn);
      instance.calendarContainer.appendChild(slotsEl);
    }

    function setConfirm(text, enabled) {
      confirmBtn.textContent = text;
      confirmBtn.disabled = !enabled;
      confirmBtn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    }

    function renderSlots(instance) {
      if (!slotsEl) return;
      slotsList.innerHTML = '';
      slotsEl.classList.toggle('is-complete', !!(state.date && state.hour !== null));

      if (!state.date) {
        slotsTitle.textContent = 'Alege o zi din calendar';
        setConfirm('Alege ziua și intervalul orar', false);
        return;
      }

      var r = slotRange(state.date);
      if (!r) {
        slotsTitle.textContent = 'Nu mai sunt intervale disponibile în această zi — alege altă zi';
        setConfirm('Alege altă zi', false);
        return;
      }

      slotsTitle.textContent = (state.hour === null ? 'Alege intervalul orar · ' : 'Interval orar · ') + formatDayLabel(state.date);

      for (var h = r.min; h <= r.max; h++) {
        (function (hour) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'trava-slot' + (hour === state.hour ? ' is-selected' : '');
          b.setAttribute('aria-pressed', hour === state.hour ? 'true' : 'false');
          b.textContent = slotLabel(hour);
          b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            state.hour = hour;
            commit(instance);
            renderSlots(instance);
          });
          slotsList.appendChild(b);
        })(h);
      }

      if (state.hour === null) {
        setConfirm('Alege intervalul orar', false);
      } else {
        setConfirm('Confirmă: ' + formatDayLabel(state.date) + ', ' + slotLabel(state.hour), true);
      }
    }

    // Flatpickr desenează mereu 6 săptămâni; dacă a 6-a e integral din luna următoare, o ascundem (5 rânduri, ca pe iPhone)
    function trimTrailingWeek(instance) {
      var days = instance.calendarContainer.querySelectorAll('.dayContainer .flatpickr-day');
      if (days.length !== 42) return;
      var allNext = true;
      for (var i = 35; i < 42; i++) {
        if (!days[i].classList.contains('nextMonthDay')) { allNext = false; break; }
      }
      for (var j = 35; j < 42; j++) {
        days[j].classList.toggle('trava-hidden-day', allNext);
      }
    }

    var fpOptions = {
      enableTime: false,
      dateFormat: 'Y-m-d',
      enable: enableDates,
      disable: [
        function (date) {
          return !TD.hasAvailableSlot(TD.ymdFromDate(date), now);
        }
      ],
      locale: RO_LOCALE,
      monthSelectorType: 'static',
      closeOnSelect: false,
      static: false,
      disableMobile: true,

      onReady: function (selectedDates, dateStr, instance) {
        instance.calendarContainer.classList.add('trava-fp');
        buildSlotsPanel(instance);
        instance.input.value = '';
        setHiddenInputs({ date: '', time: '' });
        renderSlots(instance);
        trimTrailingWeek(instance);
      },

      onOpen: function (selectedDates, dateStr, instance) {
        // Recalculăm 'now' la fiecare deschidere — clientul poate sta mult în pagină.
        // set() rescrie câmpul în formatul brut al Flatpickr → după el refacem noi valoarea.
        now = TD.nowInBucharest();
        instance.set('enable', TD.buildAllowedDates(now));

        if (state.date && !TD.hasAvailableSlot(state.date, now)) {
          // ziua aleasă nu mai are intervale → se anulează, clientul alege altă zi
          state.date = null;
          state.hour = null;
          instance.clear(false);
        } else {
          dropHourIfInvalid();
        }

        if (state.date && state.hour !== null) {
          commit(instance);
        } else {
          clearValue(instance);
        }

        renderSlots(instance);
        trimTrailingWeek(instance);
        document.body.classList.add('trava-fp-open');
      },

      onMonthChange: function (selectedDates, dateStr, instance) {
        trimTrailingWeek(instance);
      },

      onYearChange: function (selectedDates, dateStr, instance) {
        trimTrailingWeek(instance);
      },

      onClose: function () {
        document.body.classList.remove('trava-fp-open');
      },

      onChange: function (selectedDates, dateStr, instance) {
        if (!selectedDates.length) {
          // fp.clear() din checkout-validation.js sau din onOpen
          state.date = null;
          state.hour = null;
          clearValue(instance);
          renderSlots(instance);
          trimTrailingWeek(instance);
          return;
        }
        var ds = TD.ymdFromDate(selectedDates[0]);
        if (!TD.hasAvailableSlot(ds, now)) {
          renderSlots(instance);
          trimTrailingWeek(instance);
          return;
        }
        if (ds !== state.date) {
          // zi nouă → intervalul se alege din nou
          state.date = ds;
          state.hour = null;
          clearValue(instance);
        }
        renderSlots(instance);
        trimTrailingWeek(instance);
      }
    };

    var fp = flatpickr(input, fpOptions);

    // Expunem instanța global pentru checkout-validation.js (open / clear / input)
    window.travaFlatpickrInstance = fp;
  }

  // ═══════════════════════════════════════════════════════════════════════════
  // PORNIRE + CART DRAWER PROTECTION (neschimbat)
  // ═══════════════════════════════════════════════════════════════════════════
  function bindCartDrawerRedirect() {
    try {
      var btn = document.querySelector('cart-notification button[name="checkout"]');
      if (btn && !btn.classList.contains('trava-bound')) {
        btn.classList.add('trava-bound');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
          window.location.href = cartUrl;
        });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindCartDrawerRedirect();
      initFlatpickr();
    });
  } else {
    bindCartDrawerRedirect();
    initFlatpickr();
  }

})();